export interface ThemeProps {
    target: string;
    animation: string;
    base: string;
    arrow: {
        base: string;
        style: {
            auto: string;
        }
        placement: string;
    },
    hidden: string;
    content: string;
    style: {
        auto: string;
    }
}

export const tooltipTheme: ThemeProps = {
    target: "w-fit",
    animation: "transition-opacity",
    arrow: {
        base: "absolute z-10 h-2 w-2 rotate-45",
        style: {
            auto: "bg-system-primary"
        }, 
        placement: "-4px"
    },
    base: "absolute z-10 inline-block rounded px-2 py-1 font-medium shadow-sm",
    hidden: "invisible opacity-0",
    content: "relative z-20 text-label-medium",
    style: {
        auto: "bg-system-primary text-system-on-primary",
    },
}
    